import * as React from "react"
import { Center, Stack, Text } from "@chakra-ui/react"
import { useQuery } from "react-query"
import { APP_VERSION_NAME, VERSION } from "../lib/config"
import { getVersion } from "../lib/helpers/utils"

interface AppVersion {
  created: Date
  modified: Date
  version: string
  change_log: string
}

export function UpdateVersionWarning() {
  const [details, showDetails] = React.useState(false)

  const current = VERSION
  const { data } = useQuery<any, string>(`app_versions?name=${APP_VERSION_NAME}&platform=web`, {
    refetchInterval: 60000,
  })
  const latest: AppVersion = data?.results[0]

  if (latest) {
    const currentVersion = getVersion(current)
    const latestVersion = getVersion(latest.version)

    if (!currentVersion || !latestVersion) return null

    const updateAvailable = () => {
      if (latestVersion[0] > currentVersion[0]) return true
      if (latestVersion[0] === currentVersion[0]) {
        if (latestVersion[1] > currentVersion[1]) return true
        if (latestVersion[1] === currentVersion[1]) {
          if (latestVersion[2] > currentVersion[2]) return true
        }
      }
      return false
    }

    if (updateAvailable())
      return (
        <Center zIndex={1000} pos="fixed" top={0} left={0} bg="blue.500" w="100%" p={1}>
          <Stack>
            <Text color="white" fontSize="xs" fontWeight="bold">
              FMS version {latest.version} is available, refresh the page to update.
              {latest.change_log.trim().length > 0 && (
                <>
                  &nbsp;
                  <a
                    style={{ textDecoration: "underline", cursor: "pointer" }}
                    onClick={() => showDetails((d) => !d)}
                  >
                    {details ? "Hide details" : "Show details"}
                  </a>
                </>
              )}
            </Text>
            {details && (
              <Stack spacing={0} pb={2}>
                {latest.change_log.split(";").map((log, idx) => (
                  <Text color="white" fontSize="xs" fontWeight="regular" key={idx}>
                    {log}
                  </Text>
                ))}
              </Stack>
            )}
          </Stack>
        </Center>
      )
  }

  return null
}
